import moment from 'moment';

const calculateLenderAdvance = (row, advances) => {
  const { date } = row;

  const lenderAdvances = advances?.filter((advance) =>
    moment(advance.date).isSame(date, 'month')
  );

  const totalLenderAdvance = lenderAdvances?.reduce(
    (acc, advance) => acc + advance.amount,
    0
  );

  return totalLenderAdvance !== 0 ? totalLenderAdvance : '-';
};

export default calculateLenderAdvance;
